import { Model } from 'pinia-orm';
import Application from './Application';

export default class ApplicationField extends Model {

    static get entity () {
        return 'application-field'
    }

    static fields () {
        return {
            id: this.uid(),
            application_id: this.attr(null),
            name: this.attr(null),
            value: this.attr(null),
            visibility: this.attr('all'),
            users: this.attr([]),
            user_id: this.attr(null),
            created_at: this.attr(null)
        }
    }
}
